// extracted by mini-css-extract-plugin
export default {"customEditor":"TextEditor_customEditor__YuINF","customImageLimit":"TextEditor_customImageLimit__PVaA9"};